(function () {
  var sections = document.querySelectorAll('[data-ugc-videos]');

  sections.forEach(function (section) {
    var scroll = section.querySelector('[data-ugc-scroll]');
    var cards = section.querySelectorAll('[data-ugc-card]');
    var prevBtn = section.querySelector('[data-ugc-arrow="prev"]');
    var nextBtn = section.querySelector('[data-ugc-arrow="next"]');

    if (!scroll || cards.length === 0) return;

    // --- Scroll arrows ---
    function setArrow(btn, show) {
      btn.style.opacity = show ? '1' : '0';
      btn.style.pointerEvents = show ? 'auto' : 'none';
    }
    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      // When the cards all fit (e.g. 4 cards on desktop fill the row), there's
      // nothing to scroll — hide both arrows rather than show a dead "next".
      var maxScroll = scroll.scrollWidth - scroll.clientWidth;
      if (maxScroll <= 8) {
        setArrow(prevBtn, false);
        setArrow(nextBtn, false);
        return;
      }
      setArrow(prevBtn, scroll.scrollLeft > 10);
      setArrow(nextBtn, scroll.scrollLeft + scroll.clientWidth < scroll.scrollWidth - 10);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scroll.scrollBy({ left: -scroll.clientWidth * 0.8, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scroll.scrollBy({ left: scroll.clientWidth * 0.8, behavior: 'smooth' });
      });
    }

    scroll.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // --- Mute icon helper ---
    function updateMuteIcon(btn, muted) {
      var offIcon = btn.querySelector('.ugc-mute-icon--off');
      var onIcon = btn.querySelector('.ugc-mute-icon--on');
      if (offIcon) offIcon.style.display = muted ? 'block' : 'none';
      if (onIcon) onIcon.style.display = muted ? 'none' : 'block';
    }

    // --- Lazy-attach video src when card approaches viewport ---
    // Videos are rendered with data-src instead of src so the browser doesn't
    // start fetching MP4s on initial page load. We swap the attribute as soon
    // as the card is within ~1 viewport of becoming visible, then load() so
    // Safari/iOS pick up the new source reliably.
    function attachVideoSrc(video) {
      if (!video || video.src || !video.dataset.src) return;
      video.src = video.dataset.src;
      video.removeAttribute('data-src');
      // preload="metadata" only after we've decided to actually load this card
      video.preload = 'metadata';
      try { video.load(); } catch (e) {}
    }

    // rootMargin: 50% means we attach src about half a viewport before the
    // card scrolls in. The previous 200% setting was downloading several
    // MB of video on initial page load even for cards far below the fold,
    // which the Lighthouse audit flagged as the dominant network payload.
    var preloadObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            attachVideoSrc(entry.target.querySelector('video'));
            preloadObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '50% 0px 50% 0px' }
    );

    // --- Click to play ---
    // Autoplay was causing all visible cards to play simultaneously on desktop
    // (where 4 cards fit on screen at once). Now it's tap/click-driven: click a
    // card to play, click again to pause. Starting another card pauses the
    // current one so only one ever plays at a time.
    function pauseAll(except) {
      cards.forEach(function (card) {
        if (card === except) return;
        var video = card.querySelector('video');
        if (video) {
          if (!video.paused) video.pause();
          video.muted = true;
        }
        var btn = card.querySelector('[data-ugc-mute]');
        if (btn) updateMuteIcon(btn, true);
        card.removeAttribute('data-playing');
      });
    }

    cards.forEach(function (card) {
      preloadObserver.observe(card);

      // Click anywhere on the card (except the mute button) toggles playback
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-ugc-mute]')) return;
        var video = card.querySelector('video');
        if (!video) return;

        if (video.paused) {
          attachVideoSrc(video);
          pauseAll(card);
          // Stay muted on first click — user can unmute via the mute button.
          // Avoids a sudden audio surprise on mobile.
          video.muted = true;
          var p = video.play();
          if (p && typeof p.then === 'function') {
            p.then(function () {
              card.setAttribute('data-playing', 'true');
            }).catch(function () {});
          } else {
            card.setAttribute('data-playing', 'true');
          }
        } else {
          video.pause();
          card.removeAttribute('data-playing');
        }
      });

      // Reset visual state when video ends or is paused externally
      var v = card.querySelector('video');
      if (v) {
        v.addEventListener('pause', function () {
          card.removeAttribute('data-playing');
        });
        v.addEventListener('play', function () {
          card.setAttribute('data-playing', 'true');
        });
      }

      var muteBtn = card.querySelector('[data-ugc-mute]');
      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var video = card.querySelector('video');
          if (!video) return;

          if (video.muted) {
            // Unmute this one, mute all others
            cards.forEach(function (other) {
              if (other === card) return;
              var ov = other.querySelector('video');
              if (ov) ov.muted = true;
              var ob = other.querySelector('[data-ugc-mute]');
              if (ob) updateMuteIcon(ob, true);
            });
            video.muted = false;
            updateMuteIcon(muteBtn, false);
          } else {
            video.muted = true;
            updateMuteIcon(muteBtn, true);
          }
        });
      }
    });
  });
})();
